var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1157",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1157",
    transform: "translate(0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_27",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 27",
    d: "M-321.268,306.206h2.978v-2.894c0-1.276.032-3.244.959-4.463a5.3,5.3,0,0,1,4.623-2.169,18.7,18.7,0,0,1,5.339.537l-.744,4.412a10.046,10.046,0,0,0-2.4-.359c-1.159,0-2.2.416-2.2,1.574v3.364h4.749l-.331,4.309h-4.418v14.971h-5.583V310.516h-2.978Z",
    transform: "translate(339.225 -286.378)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_23",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 23",
    transform: "translate(-0.25)",
    fill: "none",
    stroke: "#d19f46",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.6f2348b56683d6063070b5fa08e48c2d.svg";
export { ForwardRef as ReactComponent };